import * as React from 'react';
import { Hr, Text } from '@grandvisionhq/elements';

const DonationSummary = ({ formattedDonationAmount , label , disclaimer  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement("div", {
        className: "donation-summary"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "donation-summary__text"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "donation-summary__title",
        color: "text-primary"
    }, label), /*#__PURE__*/ React.createElement(Text, {
        className: "donation-summary__amount",
        color: "text-primary"
    }, formattedDonationAmount)), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, disclaimer)))
;

export { DonationSummary };
//# sourceMappingURL=DonationSummary.js.map
